'use client';

import React from 'react';
import Slider, { Settings } from 'react-slick';

import './styles.scss';

interface ICarouselProps {
  slides: React.ReactNode[];
  settings?: Settings;
}

const Carousel: React.FC<ICarouselProps> = ({ slides, settings }) => {
  return (
    <div>
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={index}>{slide}</div>
        ))}
      </Slider>
    </div>
  );
};

export default Carousel;
